<template>
    <div :class="{
            'update-info-post position-absolute' : true,
            'update-info-post-mobile' : $detect == 'mobile'
        }">
        <div :class="{
                    'edit-post offset-6 col-6 pl-2 pr-0' : true,
                    'm-0 col-12' : $detect == 'mobile'
                }" v-loading="loading">
            <div class="card-dashboard">
                <div class="py-10px px-3 border-bottom border-primary title-popup-mobile">
                    <span class="mb-0">Chỉnh sửa thông tin</span>
                    <div class="close" role="button" @click="updateCheck = 0">
                        <i class="icon ion-md-close" v-if="$detect == 'web'"></i>
                        <i class="icon ion-ios-arrow-back" v-if="$detect == 'mobile'"></i>
                    </div>
                </div>
                <div class="content p-3">
                    <div class="d-flex">
                        <div class="w-title">
                            Danh mục:
                        </div>
                        <div class="w-value">
                            <ldc-dropdown
                                trigger="click"
                                :action-close="true"
                                :active-dropdown.sync="activeCategory">
                                <button role="button" class="fs-14px dropdown-category px-2 btn-block text-left"
                                    :disabled="!(form.post_date * 1000 > ((new Date()).getTime() - 86400000) && form.status == 1)">
                                    {{ form.category ? form.category.name : '' }}
                                </button>
                                <ldc-dropdown-menu>
                                    <div class="category">
                                        <div class="search-category">
                                            <div class="input-icon mb-2">
                                                <input type="text" placeholder="Nhập danh mục cần tìm" v-model="keyword"/>
                                                <i class="icon ion-ios-search"></i>
                                            </div>
                                            <div class="btn-search-category pl-10px text-primary fs-14px"
                                                role="button" v-show="status_category == 2" @click="status_category = 1">
                                                Danh sách danh mục
                                            </div>
                                            <div class="btn-search-category pl-10px text-primary fs-14px"
                                                role="button" v-show="status_category == 1 && categories_search.length > 0" @click="status_category = 2">
                                                Danh sách tìm kiếm danh mục
                                            </div>
                                            <div class="back-category pl-10px text-danger" role="button"
                                                v-show="id_cat.length > 0 && status_category == 1" @click="goBack()">
                                                <i class="icon ion-md-arrow-back mr-2 fs-18px"></i>Quay lại
                                            </div>
                                        </div>
                                        <div class="list-category vg-scrollbar" v-show="status_category == 1">
                                            <div class="list-item p-10px"
                                                role="button"
                                                v-for="(category, index) in categories" :key="index"
                                                @click="category.has_child ? getChild(category) : closeCategory(category)">
                                                <span class="name fs-14px">{{ category.name }}</span>
                                                <span class="icon float-right" v-if="category.has_child == true">
                                                    <i class="icon ion-ios-arrow-forward fs-16px"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="list-category vg-scrollbar" v-show="status_category == 2">
                                            <div class="list-item p-10px"
                                                role="button"
                                                v-for="(category, index) in categories_search" :key="index"
                                                @click="closeCategory(category)">
                                                <span class="name fs-14px">{{ category.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ldc-dropdown-menu>
                            </ldc-dropdown>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Tiêu đề:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" v-model="form.name"/>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.name">
                                {{error.name}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Giá:</div>
                        <div class="w-value">
                            <div class="input-icon">
                                <input type="text" class="input-vg text-danger" inputmode="numeric" v-model="form.price"
                                    @input="formatPrice()" @focus="(e) => e.target.select()"/>
                                <span class="text-danger">VNĐ</span>
                            </div>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.price">
                                {{error.price}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Địa chỉ:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" v-model="form.poster_address"/>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.poster_address">
                                {{error.poster_address}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Tỉnh thành:</div>
                        <div class="w-value">
                            <ldc-select
                                v-if="form.city"
                                v-model="form.city.id"
                                placeholder="Chọn tỉnh thành">
                                <ldc-option
                                    v-for="(item, index) in countries" :key="index"
                                    :value="item.id"
                                    :label="item.name"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Loại tin:</div>
                        <div class="w-value">
                            <ldc-select
                                placeholder="Chọn loại tin"
                                v-model="form.type">
                                <ldc-option
                                    :value="0"
                                    label="Cần bán"/>
                                <ldc-option
                                    :value="1"
                                    label="Cần Mua"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Trạng thái:</div>
                        <div class="w-value">
                            <ldc-select
                                placeholder="Chọn trạng thái"
                                v-model="form.new_old">
                                <ldc-option
                                    :value="0"
                                    label="Hàng mới"/>
                                <ldc-option
                                    :value="1"
                                    label="Hàng cũ"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Người đăng:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" v-model="form.poster_name"/>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.poster_name">
                                {{error.poster_name}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Điện thoại:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" inputmode="numeric" v-model="form.poster_phone"
                                @input="formatPhone()" @focus="(e) => e.target.select()"/>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.poster_phone">
                                {{error.poster_phone}}
                            </div>
                        </div>
                    </div>
                    <div class="btn-confirm text-center mt-4">
                        <button class="btn btn btn-secondary btn-sm mr-2" @click="updateCheck = 0" v-if="$detect == 'web'">Huỷ</button>
                        <button class="btn btn-primary btn-sm ml-2" @click="submit()">Cập nhật</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['active', 'data'],
    data() {
        return {
            updateCheck: 0,
            countries: [],
            form: {},
            categories : [],
            categories_search : [],
            id_cat: [],
            keyword: '',
            timeOutStatus: null,
            activeCategory: false,
            status_category: 1,
            id: this.$route.params.id,
            loading: false
        }
    },
    watch: {
        active(val){
            this.updateCheck = val;
        },
        updateCheck(val){
            this.$emit('update:active', val);
        },
        keyword(val){
            if(val.length >= 3){
                this.status_category = 2;
                if(this.timeOutStatus) clearTimeout(this.timeOutStatus);
                this.timeOutStatus = setTimeout(() => {
                    this.getCategorySearch();
                }, 300)
            }
        },
        data: {
            handler(val){
                this.form = {
                    category: val.category,
                    poster_address: val.poster_address,
                    city: val.city,
                    price: this.$formatNumber(val.price),
                    type: val.type,
                    new_old: val.new_old,
                    poster_name: val.poster_name,
                    poster_phone: val.poster_phone,
                    post_date: val.post_date,
                    status: val.status,
                    name: val.name,
                    status_expire: val.status_expire,
                }
            },
            deep: true,
        }
    },
    computed:{
        error(){
            return this.$store.state.errorPutRv;
        }
    },
    created() {
        apiGet('/v2/profile/country').then(res => {
            this.countries = res.data;
        });
        this.getCategory();
        this.form = {
            category: this.data.category,
            poster_address: this.data.poster_address,
            city: this.data.city,
            price: this.$formatNumber(this.data.price),
            type: this.data.type,
            new_old: this.data.new_old,
            poster_name: this.data.poster_name,
            poster_phone: this.data.poster_phone,
            post_date: this.data.post_date,
            status: this.data.status,
            name: this.data.name,
            status_expire: this.data.status_expire,
        }
    },
    methods: {
        formatPrice(){
            let price = this.form.price.replace(/[^0-9]/g, '');
            this.form.price = this.$formatNumber(price)
        },
        formatPhone(){
            this.form.poster_phone = this.$formatNumberPhome(this.form.poster_phone)
        },
        getCategory(parent_id = 0){
            apiGet('/v1/categories', {
                module: 'raovat',
                parent_id: parent_id,
            }).then(res => {
                this.categories = res.data;
            });
        },
        getChild(category) {
            this.getCategory(category.id);
            this.id_cat.push(category.id);
        },
        closeCategory(category) {
            this.form.category = {
                id: category.id,
                name: category.name
            }
            this.activeCategory = false;
        },
        async goBack() {
            let parent_id = 0;
            if(this.id_cat.length > 1) {
                parent_id = this.id_cat[this.id_cat.length -2];
            }
            await this.getCategory(parent_id);
            this.id_cat.splice(this.id_cat.length - 1, 1);
        },
        getCategorySearch() {
            if(this.keyword.length >= 3){
                apiGet('/v2/raovat/search_categories', {
                    keyword: this.keyword
                }).then(res => {
                    this.categories_search = res.data;
                })
            }
        },
        submit(){
            let data = {
                category: this.form.category.id,
                poster_name: this.form.poster_name,
                poster_address: this.form.poster_address,
                poster_phone: this.form.poster_phone,
                list_country: [this.form.city.id],
                type: this.form.type,
                price: this.$stringToNumber(this.form.price),
                new_old: this.form.new_old,
                name: this.form.name,
            }
            this.loading = false;
            apiPut(`/v2/profile/raovat/${this.id}`, data).then(res => {
                this.loading = false;
                if(res.success == 1){
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    this.form.status = res.data.status;
                    this.emitData();
                    this.$store.commit('dataErrorPutRv', {})
                }else{
                    this.$message({
                        message: res.message,
                        type: 'error',
                        center: true,
                    })
                }
            }).catch(err => {
                this.loading = false;
                if(err.status == 422){
                    this.$store.commit('dataErrorPutRv', err.data);
                }
            })
        },
        emitData(){
            this.form.city.name = this.countries[this.form.city.id].name;
            this.form.category.name = this.getNameCategory();
            this.$emit('dataEmit', this.form);
            this.updateCheck = 0;
        },
        getNameCategory(){
            let name = '';
            this.categories.map(item => {
                if(item.id === this.form.category.id){
                    name = item.name
                }
            })
            if(name === ''){
                this.categories_search.map(item => {
                    if(item.id === this.form.category.id){
                        name = item.name
                    }
                });
            }
            if(name === ''){
                name = this.form.category.name;
            }
            return name;
        }
    }
}
</script>

<style lang="scss">
    .update-info-post {
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        background: rgba(240, 245, 249, 0.8);
        input {
            &:focus {
                outline: none !important;
            }
        }
        .edit-post {
            .content {
                .w-title {
                    width: 150px;
                    font-size: 14px;
                    line-height: 40px;
                    color: #666;
                }
                .w-value {
                    width: calc( 100% - 150px );
                    .dropdown-category {
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        height: 40px;
                        line-height: 40px;
                        border-radius: 4px;
                        background: #fff;
                    }
                    [disabled] {
                        background: rgba(0, 0, 0, 0.1);
                    }
                    .ldc-input-select {
                        .ldc-input {
                            border:1px solid rgba(0, 0, 0, 0.2) !important;
                            color: #000 !important;
                        }
                    }
                    .input-icon {
                        position: relative;
                        input {
                            width: 100%;
                            background-color: white;
                            border-radius: 4px;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            padding: 0 50px 0 10px;
                            transition: border 0.2s ease-in;
                            height: 40px;
                        }
                        span {
                            font-weight: 600;
                            color: #000;
                            font-size: 14px;
                            position: absolute;
                            right: 14px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .err-form-uptdate {
                        margin-top: 2px;
                    }
                }
                .btn-confirm {
                    button {
                        width: 120px;
                    }
                }
                .category {
                    .input-icon {
                        position: relative;
                        input {
                            width: 100%;
                            background-color: white;
                            border-radius: 4px;
                            border: 1px solid rgba(0, 0, 0, 0.1);
                            padding: 0 40px 0 10px;
                            transition: border 0.2s ease-in;
                            height: 40px;
                            &:focus {
                                border-color: #2979ff;
                            }
                        }
                        i {
                            color: #000;
                            font-size: 20px;
                            position: absolute;
                            right: 14px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .btn-search-category {
                        height: 30px;
                        line-height: 30px;
                    }
                    .back-category {
                        height: 30px;
                        i {
                            vertical-align: -1px;
                        }
                    }
                }
                .list-category {
                    height: 368px;
                    overflow-y: auto;
                    .list-item {
                        &:hover {
                            background: #eee;
                            border-radius: 4px;
                        }
                    }
                }
            }
        }
    }
    .update-info-post-mobile {
        position: fixed !important;
        height: 100vh !important;
        .edit-post {
            padding: 0 !important;
            .card-dashboard {
                height: 100vh;
                overflow-y: auto;
                border-radius: 0 !important;
            }
            .w-title {
                width: 100px !important;
            }
            .w-value {
                width: calc( 100% - 100px ) !important;
            }
            .dropdown-category {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .btn-confirm {
            button {
                margin-left: 0 !important;
                height: 40px;
                width: 200px !important;
            }
        }
        .title-popup-mobile {
            background: #007bff;
            color: #fff;
            text-align: center;
            .close {
                float: left;
                i {
                    color: rgba(255, 255, 255, 1.0);
                    padding-right: 20px;
                }
            }
            span {
                margin-left: -29px;
            }
        }
    }
</style>
